export default [
  {
    path: "dashboard",
    components: {
      default: {
        name: "ClientDashboard",
        template: `<router-view />`
      }
    },
    meta: {},
    children: [
      {
        path: "",
        name: "clientDashboard",
        component: () => import("@/views/client/dashboard/index.vue"),
        meta: {
          title: "_.dashboard",
          breadcrumb: {
            label: "_.dashboard"
          }
        }
      }
    ]
  }
];
